import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiErrorDetail } from "../lib/api";
import EmployerLayout from "./EmployerLayout";
import { useAppT } from "../components/home/i18n";
import { Star, Trash2 } from "lucide-react";

export default function EmployerShortlist() {
  const { a } = useAppT();
  const [items, setItems] = useState([]);
  const [blocked, setBlocked] = useState(null);
  const load = async () => {
    try { const { data } = await API.get("/employer/shortlist"); setItems(data.shortlist); }
    catch (e) { if (e.response?.status === 403) setBlocked(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);
  const remove = async (pid) => { try { await API.delete(`/employer/shortlist/${pid}`); load(); } catch { toast.error(a.common.failed); } };

  return (
    <EmployerLayout>
      <h1 className="font-serif text-3xl text-[#173A2C]">{a.empShortlist.title}</h1>
      {blocked ? <div className="mt-4 rounded-md border border-[#8B3A3A]/30 bg-[#8B3A3A]/6 p-4 text-sm text-[#8B3A3A]">{blocked}</div> : (
        <div className="mt-6 space-y-2" data-testid="shortlist-list">
          {items.length === 0 && <div className="text-sm text-[#5C5855]">{a.empShortlist.empty}</div>}
          {items.map((s) => (
            <div key={s.profile_id} className="flex items-center gap-3 rounded-md border border-[#E8E4DB] bg-white p-3">
              <Star className="h-4 w-4 text-[#C4A46B]" />
              <div className="flex-1"><div className="font-semibold text-[#173A2C]">{s.alias}</div><div className="text-xs text-[#5C5855]">{s.headline} · {s.broad_location} · {(s.professions || []).join(", ")}</div></div>
              <button data-testid={`unshortlist-${s.alias}`} onClick={() => remove(s.profile_id)} className="text-[#8B3A3A]"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </EmployerLayout>
  );
}
